import React, { useState, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "react-hot-toast";
import "../css/Common.css";
import "../css/RepaymentDetails.css"; // Assuming the CSS is defined here
import qr_image from "../images/SellerQR.jpg";
import qr2 from "../images/qr2.png";
import udhaarportaQr from "../images/snap_paisa_qr.jpg";
import qrCodeImage from "../images/qr.jpg";
import ChatButton from "../components/ChatButton";
import { useNavigate } from "react-router-dom";
import PaymentModal from "../components/Payment/PaymentModal";
import CryptoJS from "crypto-js"; // Importing the crypto-js library
import { APP_NAME, NBFC_NAME } from "../Utils/constant";
import SecurityAlertContent from "../components/SecurityAlert/SecurityAlertContent";

const showMessage = (message) => {
  toast.success(message);
};

const RepayLoan = (props) => {
  const [content, setContent] = useState("pannumber");
  const [getLoading, setLoading] = useState(false);
  const [pancard, setGetPancard] = useState("");
  const [getPancard, setPancard] = useState("");
  const [getOtp, setOtp] = useState("");
  const [repaymentData, setRepaymentData] = useState(null);
  const [orderId, setOrderId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState(); // New state for part payment
  const navigate = useNavigate();
  const [upiId] = useState("yespay.ypbsm000006396@yesbankltd");
  const [userData, setUserData] = useState({});
  const [isFetching, setIsFetching] = useState(false);
  const [showSecurityAlert, setShowSecurityAlert] = useState(false);
  const upiLink = `upi://pay?pa=${upiId}&pn=POSUser&am=${repaymentData?.["total_due_amount"]}&cu=INR`;

  useEffect(() => {
    const seen = sessionStorage.getItem("securityAlertSeen");
    if (!seen) {
      setShowSecurityAlert(true);
    }
  }, []);

  useEffect(() => {
    if (showSecurityAlert) {
      const original = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = original;
      };
    }
  }, [showSecurityAlert]);

  const handleCloseSecurityAlert = () => {
    sessionStorage.setItem("securityAlertSeen", "true");
    setShowSecurityAlert(false);
  };

  const sendOtp = async () => {
    setLoading(true);
    try {
      const resp = await fetch("https://crm.udhaarporta.com/api/Api/CustomerDetails/Sendotp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Auth: "Y2M0Nzk0OGYwNmQyMjdmZTlhY2E1ZWQ1Nzk5YTZmMWE=",
          Accept: "application/json",
        },
        body: JSON.stringify({ pancard: getPancard }),
      });

      if (resp.status === 200) {
        const dataset = await resp.json();
        props.showmessage(dataset.Message);
        if (dataset.Status === 1) {
          setContent("panotp");
        }
      }else{
        const dataset=await resp.json();
        props.showmessage(dataset.Message);
      }
    } catch (error) {

      console.error("Error sending OTP:", error);
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {  
    setLoading(true);
    try {
      const resp = await fetch("https://crm.udhaarporta.com/api/Api/CustomerDetails/verifyOtp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Auth: "Y2M0Nzk0OGYwNmQyMjdmZTlhY2E1ZWQ1Nzk5YTZmMWE=",
          Accept: "application/json",
        },
        body: JSON.stringify({
          panNumber: getPancard,
          // otp: getOtp,
        }),
      });

      if (resp.status === 200) {
        const dataset = await resp.json();
        props.showmessage(dataset.Message);

        if (dataset.Status === 1) {
          const repaymentData = dataset.repayment_data;
          setRepaymentData(repaymentData);
          setOrderId(dataset.order_id);
          setContent("amountfetched");
        }
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
    } finally {
      setLoading(false);
    }
  };

  const payHere = async () => {
    setLoading(true);
    try {
      // Guard: require a valid order id before opening Razorpay
      if (!orderId) {
        console.error("Missing orderId. Generate order before payment.");
        setLoading(false);
        return;
      }

      var total_due_amount = repaymentData.total_due_amount;
      if (paymentAmount < repaymentData.total_due_amount) {
        total_due_amount = paymentAmount; // Use part payment amount if provided
      }

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_xxxxxxxxxxxxx",
        amount: (total_due_amount * 100).toString(),
        currency: "INR",
        name: {APP_NAME},
        description: getPancard,
        image: "https://crm.udhaarporta.com/public/images/18-BK_kixu8.png",
        order_id: orderId,
        prefill: {
          name: "Hidden",
          email: repaymentData.email,
          contact: repaymentData.mobile,
        },
        theme: { color: "#8180e0" },
        handler: function (response) {
          const paymentDetails = {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
          };

          fetch("https://crm.udhaarporta.com/api/Api/CustomerDetails/verifyRazorPayCheckPaymentStatus", {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
              Auth: "Y2M0Nzk0OGYwNmQyMjdmZTlhY2E1ZWQ1Nzk5YTZmMWE=",
              Accept: "application/json",
            },
            body: JSON.stringify(paymentDetails),
          })
          .then((res) => res.json())
          .then((data) => {
            let txnStatus = data.status
            let txnId = data.txnId || "N/A";  // Get txnId from response if available

            // Pass txnStatus and txnId to the thank you page using navigate
            navigate("/thanku", {
              state: {
                txnStatus: txnStatus,
                txnId: txnId,
              },
            });

            setPaymentStatus(txnStatus === 'SUCCESS' ? "Payment Successful" : "Payment Verification Failed");
            setContent(txnStatus === 'SUCCESS' ? "paymentSuccess" : "paymentFailure");
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error verifying payment:", error);
            setPaymentStatus("Payment Verification Failed");
            setLoading(false);
          });
        },
      };

      const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
      if (res) {
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      } else {
        alert("Razorpay SDK failed to load. Are you online?");
      }
    } catch (error) {
      console.error("Error during payment:", error);
      setLoading(false);
    }
  };


  let processing = false; 
  const payWithPayU = async () => {
    if (processing) return;
    processing = true;

    setLoading(true);
    try {
      const total_due_amount = paymentAmount || repaymentData.total_due_amount; // Use part payment amount if provided
      const MERCHANT_KEY = "LrvBUp"; 
      const productinfo = "Loan repayment for Loan No"; 
      const fullname = repaymentData.full_name;
      const email = repaymentData.email;
      const phone = repaymentData.mobile;

      const response = await fetch("https://crm.udhaarporta.com/api/Api/RepayLoanApi/payuOrders", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",
          "Auth":"MjFmMTdiYjE0MTM3Y2YxODQxYjhiMGEwNTY4M2I1ZDE="
        },
        body: JSON.stringify({
          amount: total_due_amount,
          productinfo: productinfo,
          firstname: fullname,
          email: email,
          mobile: phone,
          udf5: repaymentData.lead_id
        }),
      });

      const data = await response.json();

      if (data.Status === 1) {
        const hashData = data.data.parameters;

        const payuOptions = {
          key: MERCHANT_KEY,
          txnid: hashData.txnid,
          amount: total_due_amount,
          productinfo: productinfo,
          firstname: fullname,
          email: email,
          phone: phone,
          surl: "https://udhaarporta.com/thanku",
          furl: "https://udhaarporta.com/fail",
          hash: hashData.hash,
          udf5:repaymentData.lead_id
        };

        const scriptLoaded = await loadScript("https://jssdk.payu.in/bolt/bolt.min.js");

        if (scriptLoaded) {
          if (typeof window.bolt !== 'undefined') {
            window.bolt.launch(payuOptions, {
              responseHandler: function (BOLT) {
                if (BOLT.response.txnStatus === "SUCCESS") {
                  // Pass the transaction status to the Thank You page via React Router's state
                  navigate("/thanku", { state: { txnStatus: BOLT.response.txnStatus, txnId: BOLT.response.txnid } });
                }
                if (BOLT.response.txnStatus === "FAILED" || BOLT.response.txnStatus === "CANCEL") {
                  navigate("/thanku", { state: { txnStatus: BOLT.response.txnStatus, txnId: BOLT.response.txnid } });
                }
              },
              catchException: function (BOLT) {
                console.log('Payment failed. Please try again.');
              }
            });
          } else {
            console.error("PayU SDK not initialized correctly after loading.");
          }
        } else {
          console.error("Failed to load PayU script.");
        }
      } else {
        console.error("Failed to get valid response from PayU API.");
      }
    } catch (error) {
      console.error("Error during PayU payment:", error);
    } finally {
      setLoading(false);
      processing = false;
    }
  };



  const handlePAN = (e) => {
    const value = e.target.value.toUpperCase();
    if (/^[A-Z]{0,5}$/.test(value.slice(0, 5)) && /^[\d]{0,4}$/.test(value.slice(5, 9)) && /^[A-Z]{0,1}$/.test(value.slice(9))) {
      setPancard(value);
    }
  };

  const handleOTP = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 4) {
      setOtp(value);
    }
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };




  const handlePaymentClick = () => {
    setModalOpen(true);
    setLoading(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleRazorpay = () => {
    setModalOpen(false);
    payHere();
    setLoading(false);
  };

  const handlePayU = () => {
    setModalOpen(false);
    payWithPayU();
    setLoading(false);
  };
  const handlePaymentAmountChange = (e) => {
    let value = e.target.value;

    // Prevent the value from starting with 0, but allow decimal numbers
    if (value.length === 1 && value === '0') {
      // Do nothing if the input is just "0"
      return;
    }

    // Regex to ensure the input doesn't start with a "0" unless it's "0." (i.e., decimal number like 0.50 is allowed)
    const regex = /^(?!0(\.\d+)?)(\d*\.?\d*)$/;

    // Only update if the value matches the regex pattern
    if (regex.test(value) || value === "") {
      setPaymentAmount(value);
    }
  };

  // const handleFetchData = async (pancardValue) => {
  //   setGetPancard(pancardValue);
  //   // setLoading(true);
  //   try {
  //     const dataset = await getRepaymentDetailsByPan(pancardValue);
  //     console.log("dataset", dataset);
  //     showMessage(dataset.message);
  //     if (dataset.status === 1) {
  //       setContent("panotp");
  //     }
  //   } catch (error) {
  //     console.error("Error sending OTP:", error);
  //   } finally {
  //     // setLoading(false);
  //   }
  // };
    // const handleVerifyOtp = async (otpValue) => {
    //   setLoading(true);
    //   try {
    //       const dataset = await verifyOtp(pancard, otpValue);
    //       showMessage(dataset.Message);

    //       if (dataset.Status === 1) {
    //           const repayData = dataset.repayment_data;
    //           setRepaymentData(repayData);
    //           setOrderId(dataset.order_id);
    //           setContent("amountfetched");
    //         }
    //       } catch (error) {
    //           console.error("Error verifying OTP:", error);
    //         } finally {
    //             setLoading(false);
    //           }
    //         };
            const handleVerify = async () => {
              setLoading(true);
              try {
                const dataset = await verifyOtp(pancard);
                showMessage(dataset.Message);

                if (dataset.Status === 1) {
                  const repayData = dataset.repayment_data;
                  setRepaymentData(repayData);
                  setOrderId(dataset.order_id);
                  setContent("amountfetched");
                }
              } catch (error) {
                console.error("Error Fetching Loan Details:", error);
              } finally {
                setLoading(false);
              }
            };
            const handleSubmit = async () => {
              if (Object.keys(userData).length > 0) {
                window.location.href = upiLink;
                return;
              }

              setIsFetching(true);
              try {
                const response = await fetch(
                `https://crm.udhaarporta.com/api/Api/CustomerDetails/verifyOtp`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ pancard }),
                }
                );
                if (!response.ok) {
                  throw new Error("Failed to fetch repayment details");
                }
                const responseData = await response.json();
                if (responseData.status !== 1 || !responseData.data) {
                  setUserData({ message: "PAN not found" });
                } else {
                  setUserData(responseData.data);
                }
                console.log("response Data=>", responseData);
              } catch (error) {
                console.error("Error fetching repayment details:", error);
                throw error;
              } finally {
                setIsFetching(false);
              }
            };


            return (
            <>
            {showSecurityAlert && (
              <div className="security-alert-overlay">
                <div className="security-alert-modal" role="dialog" aria-modal="true" aria-labelledby="security-alert-heading">
                   <SecurityAlertContent headingId="security-alert-heading" />
                   <button
                     type="button"
                     className="security-alert__cta"
                     onClick={handleCloseSecurityAlert}
                   >
                     I Understand / मैं समझ गया
                   </button>
                </div>
              </div>
            )}
            <div className="page_wrapper">
              {/* Repay Loan Hero Section */}
              <section style={{
                background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 50%, #f0fdf4 100%)',
                padding: '2rem 0',
                marginTop: '0px',
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Background Elements */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: `
                    radial-gradient(circle at 20% 20%, rgba(74, 124, 89, 0.08) 0%, transparent 50%),
                    radial-gradient(circle at 80% 80%, rgba(45, 90, 39, 0.06) 0%, transparent 50%),
                    radial-gradient(circle at 40% 60%, rgba(74, 124, 89, 0.04) 0%, transparent 50%)
                  `,
                  pointerEvents: 'none'
                }}></div>
                
                
                <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem', position: 'relative', zIndex: '1' }}>
                  <div style={{ textAlign: 'center' }}>
                    {/* Badge */}
                    <div className="repay-badge" style={{
                      display: 'inline-block',
                      background: 'linear-gradient(135deg, #4A7C59, #2D5A27)',
                      color: 'white',
                      padding: '8px 20px',
                      borderRadius: '25px',
                      fontSize: '0.9rem',
                      fontWeight: '600',
                      marginBottom: '2rem',
                      boxShadow: '0 4px 14px rgba(74, 124, 89, 0.3)'
                    }}>
                      {/* 🔒 Secure & Fast Repayment */}
                </div>
                    
                    <h1 className="repay-title" style={{
                      fontSize: '4rem',
                      fontWeight: '900',
                      color: '#1f2937',
                      marginBottom: '1.5rem',
                      letterSpacing: '-0.03em',
                      lineHeight: '1.1',
                      background: 'linear-gradient(135deg, #1f2937 0%, #4A7C59 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }}>
                      Repay Your <span style={{ 
                        background: 'linear-gradient(135deg, #4A7C59, #2D5A27)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text'
                      }}>Loan</span>
                    </h1>
                    
                    <p className="repay-subtitle" style={{
                      fontSize: '1.5rem',
                      color: '#2D5A27',
                      lineHeight: '1.6',
                      marginBottom: '1rem',
                      fontWeight: '700',
                      maxWidth: '600px',
                      margin: '0 auto 1rem'
                    }}>
                      Quick & Secure Payment Solutions
                    </p>
                    
                    <p className="repay-description" style={{
                      fontSize: '1.2rem',
                      lineHeight: '1.7',
                      color: '#6b7280',
                      marginBottom: '3rem',
                      maxWidth: '700px',
                      margin: '0 auto 3rem'
                    }}>
                      Experience hassle-free loan repayment with our advanced payment gateway. 
                      Choose from multiple secure payment options including UPI, net banking, and digital wallets.
                    </p>
                    
                    {/* Feature Cards */}
                    <div className="repay-features" style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                      gap: '2rem',
                      maxWidth: '800px',
                      margin: '0 auto'
                    }}>
                      <div className="mobile-glow" style={{
                        background: 'rgba(255, 255, 255, 0.8)',
                        padding: '1.5rem',
                        borderRadius: '12px',
                        border: '1px solid rgba(74, 124, 89, 0.2)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.3s ease'
                      }}>
                        <div style={{
                          fontSize: '2rem',
                          marginBottom: '0.5rem'
                        }}>⚡</div>
                        <h3 style={{
                          fontSize: '1.1rem',
                          fontWeight: '700',
                          color: '#1f2937',
                          marginBottom: '0.5rem'
                        }}>Instant Processing</h3>
                        <p style={{
                          fontSize: '0.9rem',
                          color: '#6b7280',
                          margin: 0
                        }}>Real-time payment processing</p>
              </div>

                      <div className="mobile-glow" style={{
                        background: 'rgba(255, 255, 255, 0.8)',
                        padding: '1.5rem',
                        borderRadius: '12px',
                        border: '1px solid rgba(74, 124, 89, 0.2)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.3s ease'
                      }}>
                        <div style={{
                          fontSize: '2rem',
                          marginBottom: '0.5rem'
                        }}>🔒</div>
                        <h3 style={{
                          fontSize: '1.1rem',
                          fontWeight: '700',
                          color: '#1f2937',
                          marginBottom: '0.5rem'
                        }}>Bank-Level Security</h3>
                        <p style={{
                          fontSize: '0.9rem',
                          color: '#6b7280',
                          margin: 0
                        }}>256-bit SSL encryption</p>
                      </div>
                      
                      <div className="mobile-glow" style={{
                        background: 'rgba(255, 255, 255, 0.8)',
                        padding: '1.5rem',
                        borderRadius: '12px',
                        border: '1px solid rgba(74, 124, 89, 0.2)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.3s ease'
                      }}>
                        <div style={{
                          fontSize: '2rem',
                          marginBottom: '0.5rem'
                        }}>📱</div>
                        <h3 style={{
                          fontSize: '1.1rem',
                          fontWeight: '700',
                          color: '#1f2937',
                          marginBottom: '0.5rem'
                        }}>Multiple Options</h3>
                        <p style={{
                          fontSize: '0.9rem',
                          color: '#6b7280',
                          margin: 0
                        }}>UPI, Cards, Net Banking</p>
                      </div>
                    </div>
                  </div>
                </div>
                
              </section>

              {/* Bank Details Section - Compact */}
              <div className="bank_details_section" style={{ background: '#ffffff', padding: '1.5rem 0' }}>
                <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
                  {/* Section Header */}
                  <div className="bank-section-header">
                    <h2 style={{ 
                      fontSize: 'clamp(1.3rem, 3vw, 1.8rem)', 
                      fontWeight: '700', 
                      color: '#1f2937', 
                      marginBottom: '0',
                      lineHeight: '1.2'
                    }}>
                      Repayment - Bank Details
                    </h2>
                  </div>

                  {/* Cards Container */}
                  <div className="bank-details-wrapper">
                    {/* Bank Details Card */}
                    <div className="bank-details-card">
                      <table className="bank-details-table">
                        <tbody>
                          <tr>
                            <td className="bank-label">Company Name</td>
                            <td className="bank-value">AMAN FINCAP LIMITED</td>
                          </tr>
                          <tr>
                            <td className="bank-label">Bank</td>
                            <td className="bank-value">ICICI BANK</td>
                          </tr>
                          <tr>
                            <td className="bank-label">Account No.</td>
                            <td className="bank-value">103705001476</td>
                          </tr>
                          <tr>
                            <td className="bank-label">IFSC</td>
                            <td className="bank-value">ICIC0001037</td>
                          </tr>
                          <tr>
                            <td className="bank-label">Branch Address</td>
                            <td className="bank-value">Shop No. 5,6,10,11, Sector B, Pocket 7, Vasant Kunj, New Delhi-110070</td>
                          </tr>
                          <tr>
                            <td className="bank-label">UPI ID</td>
                            <td className="bank-value">8448694472.eazypay@icici</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* QR Code Card */}
                    <div className="qr_details">
                      <div className="qr-code-wrapper">
                        <img 
                          src={qrCodeImage} 
                          alt="QR Code for Payment" 
                          className="qr-code-image"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Modern Payment Section */}
              {/* <div className="repay_loan_wrapper" style={{ 
                background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)', 
                padding: '4rem 0',
                minHeight: '80vh'
              }}>
                <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
                  
                  <div className="payment-section-header">
                    <h2 className="payment-title">
                      Payment Options
                    </h2>
                    <p className="payment-subtitle">
                      Choose your preferred payment method for quick and secure loan repayment
                    </p>
                  </div>

                  <div className="payment-cards-container">
                    
                    <div className="payment-card">
                      <div className="card-header">
                        <div className="icon-container">
                          <span>🔐</span>
                        </div>
                        <div>
                          <h3>PAN Verification</h3>
                          <p>Verify your identity to proceed</p>
                        </div>
                      </div>

                      <div className="warning-message">
                        <p>⚠️ Please verify the accuracy of the below details before doing any transfer.</p>
                      </div>

                      <div className="pan-input-section">
                        {content === "pannumber" ? (
                        <div className="pan_number">
                          <p className="pan-note">Please verify the accuracy of the below details before doing any transfer.</p>
                          <span className="pan-label">Please enter your PAN Details</span>
                          <input 
                            type="text" 
                            value={getPancard} 
                            onChange={handlePAN} 
                            required 
                            maxLength={10}
                            className="input-field"
                            placeholder="AMCDE1232F"
                          />
                          <div className="button_container">
                            <button 
                              onClick={sendOtp}
                              className="payment-button"
                            >
                              {getLoading ? <div className="loadinganim"></div> : "Get OTP"}
                            </button>
                           
                          </div>
                        </div>
                        ) : content === "panotp" ? (
                        <div className="pan_number">
                          <p className="pan_details mb20" style={{ color: '#1f2937', fontSize: '1.1rem', fontWeight: '600', marginBottom: '1.5rem' }}>PAN NUMBER : {getPancard}</p>
                          <input
                          type="text"
                          placeholder="Please enter the OTP received"
                          value={getOtp}
                          onChange={handleOTP}
                          maxLength={4}
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              border: '2px solid rgba(74, 124, 89, 0.2)',
                              borderRadius: '8px',
                              fontSize: '1rem',
                              marginBottom: '1.5rem',
                              transition: 'all 0.3s ease',
                              outline: 'none'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#4A7C59'}
                            onBlur={(e) => e.target.style.borderColor = 'rgba(74, 124, 89, 0.2)'}
                          />
                          <p className="agreement" style={{ color: '#6b7280', fontSize: '0.9rem', lineHeight: '1.5', marginBottom: '1.5rem' }}>
                            <input type="checkbox" style={{ marginRight: '8px' }} />{" "}
                            <span>
                              To proceed with your loan application, please confirm your acceptance of our Terms and Conditions, Privacy Policy, and provide your consent for processing the payment.
                            </span>
                          </p>
                          <div className="button_container mt20 ml10">
                            <button 
                              onClick={verifyOtp}
                              style={{
                                background: 'linear-gradient(135deg, #4A7C59 0%, #2D5A27 100%)',
                                color: 'white',
                                padding: '12px 24px',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '1rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 14px rgba(74, 124, 89, 0.3)'
                              }}
                              onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                            >
                              {getLoading ? <div className="loadinganim"></div> : "Get Amount"}
                            </button>
                          </div>
                        </div>
                        )  : content === "amountfetched" && repaymentData ? (
                        <div className="repayment-card" style={{
                          background: '#ffffff',
                          borderRadius: '12px',
                          padding: '2rem',
                          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                          border: '1px solid rgba(74, 124, 89, 0.1)',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: 'linear-gradient(90deg, #4A7C59, #2D5A27)'
                          }}></div>
                          <div className="repayment-header">
                            <h2 style={{ 
                              color: '#1f2937', 
                              fontSize: '1.8rem', 
                              fontWeight: '700', 
                              marginBottom: '1.5rem',
                              textAlign: 'center'
                            }}>Loan Repayment Details</h2>
                          </div>

                          <div className="repayment-info" style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '2rem' }}>
                            <div className="info-item" style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '12px',
                              backgroundColor: '#f9f9f9',
                              borderRadius: '8px',
                              border: '1px solid rgba(74, 124, 89, 0.1)'
                            }}>
                              <span className="label" style={{ fontWeight: '600', color: '#4A7C59' }}>Loan Number:</span>
                              <span className="value" style={{ color: '#1f2937' }}>{repaymentData.loan_no}</span>
                            </div>
                            <div className="info-item" style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '12px',
                              backgroundColor: '#f9f9f9',
                              borderRadius: '8px',
                              border: '1px solid rgba(74, 124, 89, 0.1)'
                            }}>
                              <span className="label" style={{ fontWeight: '600', color: '#4A7C59' }}>Disbursal Date:</span>
                              <span className="value" style={{ color: '#1f2937' }}>{repaymentData.disbursal_date}</span>
                            </div>
                            <div className="info-item" style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '12px',
                              backgroundColor: '#f9f9f9',
                              borderRadius: '8px',
                              border: '1px solid rgba(74, 124, 89, 0.1)'
                            }}>
                              <span className="label" style={{ fontWeight: '600', color: '#4A7C59' }}>Repayment Date:</span>
                              <span className="value" style={{ color: '#1f2937' }}>{repaymentData.repayment_date}</span>
                            </div>
                            <div className="info-item" style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '12px',
                              backgroundColor: '#f9f9f9',
                              borderRadius: '8px',
                              border: '1px solid rgba(74, 124, 89, 0.1)'
                            }}>
                              <span className="label" style={{ fontWeight: '600', color: '#4A7C59' }}>Repayment Amount:</span>
                              <span className="value" style={{ color: '#1f2937' }}>₹{repaymentData.repayment_amount.toLocaleString()}</span>
                            </div>
                            <div className="info-item" style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '12px',
                              backgroundColor: '#f9f9f9',
                              borderRadius: '8px',
                              border: '1px solid rgba(74, 124, 89, 0.1)'
                            }}>
                              <span className="label" style={{ fontWeight: '600', color: '#4A7C59' }}>Loan Amount:</span>
                              <span className="value" style={{ color: '#1f2937' }}>₹{repaymentData.loan_recommended.toLocaleString()}</span>
                            </div>
                            <div className="info-item" style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '12px',
                              backgroundColor: '#f9f9f9',
                              borderRadius: '8px',
                              border: '1px solid rgba(74, 124, 89, 0.1)'
                            }}>
                              <span className="label" style={{ fontWeight: '600', color: '#4A7C59' }}>Real Interest:</span>
                              <span className="value" style={{ color: '#1f2937' }}>₹{repaymentData.real_interest.toLocaleString()}</span>
                            </div>
                            <div className="info-item" style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '12px',
                              backgroundColor: '#f9f9f9',
                              borderRadius: '8px',
                              border: '1px solid rgba(74, 124, 89, 0.1)'
                            }}>
                              <span className="label" style={{ fontWeight: '600', color: '#4A7C59' }}>Repayment With Interest:</span>
                              <span className="value" style={{ color: '#1f2937' }}>₹{repaymentData.total_due_amount.toLocaleString()}</span>
                            </div>
                            <div className="info-item due-amount" style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '12px',
                              backgroundColor: 'rgba(74, 124, 89, 0.1)',
                              borderRadius: '8px',
                              border: '2px solid #4A7C59'
                            }}>
                              <span className="label" style={{ fontWeight: '700', color: '#2D5A27' }}>Total Due Amount:</span>
                              <span className="value" style={{ color: '#2D5A27', fontWeight: '700' }}>₹{repaymentData.total_due_amount.toLocaleString()}</span>
                            </div>
                            <div className="info-item part-amount" style={{
                              display: 'flex',
                              flexDirection: 'column',
                              padding: '12px',
                              backgroundColor: '#f9f9f9',
                              borderRadius: '8px',
                              border: '1px solid rgba(74, 124, 89, 0.1)',
                              gap: '8px'
                            }}>
                              <span className="label" style={{ fontWeight: '600', color: '#4A7C59' }}>Amount To Pay</span>
                              <input
                              type="text"
                              value={paymentAmount}
                              onChange={handlePaymentAmountChange}
                              placeholder="Enter payment amount"
                                style={{
                                  width: '100%',
                                  padding: '8px 12px',
                                  border: '2px solid rgba(74, 124, 89, 0.2)',
                                  borderRadius: '6px',
                                  fontSize: '1rem',
                                  transition: 'all 0.3s ease',
                                  outline: 'none'
                                }}
                                onFocus={(e) => e.target.style.borderColor = '#4A7C59'}
                                onBlur={(e) => e.target.style.borderColor = 'rgba(74, 124, 89, 0.2)'}
                              />
                            </div>
                          </div>


                          <div className="repayment-button-container" style={{ textAlign: 'center' }}>
                            <div className="payment-btn-group" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                              <div style={{ textAlign: 'center' }}>
                                <p style={{ color: '#6b7280', fontSize: '1rem', marginBottom: '0.5rem' }}>If you want to pay part payment</p>
                                <button 
                                  className="repayment-button" 
                                  onClick={() =>
                              (window.location.href = `upi://pay?pa=yespay.ypbsm000006396@yesbankltd&pn=POSUser&am=${paymentAmount}&cu=INR`)
                                  }
                                  style={{
                                    background: 'linear-gradient(135deg, #4A7C59 0%, #2D5A27 100%)',
                                    color: 'white',
                                    padding: '12px 24px',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 4px 14px rgba(74, 124, 89, 0.3)',
                                    minWidth: '200px'
                                  }}
                                  onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                                  onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                                >
                            {getLoading ? <div className="loadinganim"></div> : "Proceed to Pay"} ₹ {paymentAmount}
                          </button>
                          </div>
                              <div style={{ textAlign: 'center' }}>
                                <p style={{ color: '#6b7280', fontSize: '1rem', marginBottom: '0.5rem' }}>If you want to pay full payment</p>
                          <button
                           onClick={() =>
                              (window.location.href = `upi://pay?pa=yespay.ypbsm000006396@yesbankltd&pn=POSUser&am=${repaymentData.total_due_amount}&cu=INR`)
                            }
                                  style={{
                                    background: 'linear-gradient(135deg, #2D5A27 0%, #1a3d1a 100%)',
                                    color: 'white',
                                    padding: '12px 24px',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 4px 14px rgba(45, 90, 39, 0.3)',
                                    minWidth: '200px'
                                  }}
                                  onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                                  onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                          >
                          {getLoading ? <div className="loadinganim"></div> : "Pay via UPI"} ₹ {repaymentData.total_due_amount}
                        </button>
                        </div>
                        </div>
                      </div>

                      {isModalOpen && (
                      <PaymentModal 
                      onClose={handleCloseModal} 
                      onRazorpay={handleRazorpay} 
                      onPayU={handlePayU} 
                      isLoading={getLoading} 
                      />
                      )}
                    </div>
                    ) : content === "paymentSuccess" ? (
                    <div className="payment-success">
                      <h3>{paymentStatus}</h3>
                      <p>Thank you for your payment!</p>
                    </div>
                    ) : null}
                  </div>
                </div>
                    {/* QR Code Payment Card */}
                    {/* <div className="payment-card"> */}
                      {/* Card Header */}
                      {/* <div className="card-header">
                        <div className="icon-container">
                          <span className="qr-icon">📱</span>
                        </div> */}
                        {/* <div>
                          <h3 className="qr-title">
                            QR Payment
                          </h3>
                          <p className="qr-subtitle">
                            Scan to pay instantly
                          </p>
                        </div> */}
                      {/* </div> */}

                      {/* QR Code */}
                      {/* <div className="qr-code-container">
                        <QRCodeCanvas
                          value={`upi://pay?pa=${upiId}&pn=POSUser&am=${repaymentData?.["total_due_amount"]}&cu=INR`}
                          size={180}
                        />
                      </div> */}

                      {/* Payment Button */}
                      {/* <div>
                        <button
                          onClick={() =>
                            (window.location.href = `upi://pay?pa=yespay.ypbsm000006396@yesbankltd&pn=POSUser&am=${repaymentData?.["total_due_amount"]}&cu=INR`)
                          }
                          className="payment-button"
                        >
                          💳 Pay ₹{repaymentData?.["total_due_amount"] || ""}
                        </button>
                      </div> */}
                    {/* </div> */}
                  {/* </div>
          </div>
        </div>  */}



        {/* <div className="bank_details_section flex flex-center space-between">
          <table className="details_table">
            <tr>
              <td><span className="account_field_value">Bank Name</span></td>
              <td><span className="account_data_value">IDFC First Bank</span></td>
            </tr>
            <tr>
              <td><span className="account_field_value">Company Name</span></td>
              <td><span className="account_data_value">Aman Fincap Pvt Ltd Collection A/c</span></td>
            </tr>
            <tr>
              <td><span className="account_field_value">Account No.</span></td>
              <td><span className="account_data_value">10182292783</span></td>
            </tr>
            <tr>
              <td><span className="account_field_value">IFSC Code</span></td>
              <td><span className="account_data_value">ICIC0008021
              </span></td>
            </tr>
            <tr>
              <td><span className="account_field_value">Branch Address</span></td>
              <td><span className="account_data_value">Ground floor, WZ-104, Plot no 46-H, Meenakshi Garden, Tilak Nagar, New Delhi - 110018</span></td>
            </tr>
            <tr>
              <td><span className="account_field_value">Account Type</span></td>
              <td><span className="account_data_value">Current</span></td>
            </tr>
          </table>
          <div className="qr_details">
            <img src={qr2} alt="QR Code" />
          </div>
        </div> */}
        <div className="repay_loan_section" style={{ background: '#ffffff', padding: '4rem 0' }}>
          <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
            <div className="pan_number" style={{
              background: '#ffffff',
              borderRadius: '12px',
              padding: '3rem',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              border: '1px solid rgba(74, 124, 89, 0.1)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                background: 'linear-gradient(90deg, #4A7C59, #2D5A27)'
              }}></div>
              <h2 style={{ 
                color: '#1f2937', 
                fontSize: '2.2rem', 
                fontWeight: '700', 
                marginBottom: '2rem',
                textAlign: 'center'
              }}>
                Here's how our loan <span style={{ color: '#4A7C59' }}>repayment</span> works:
              </h2>
              <div style={{ display: 'grid', gap: '1.5rem' }}>
                <p style={{ color: '#6b7280', fontSize: '1.1rem', lineHeight: '1.7', margin: 0 }}>
                  <strong style={{ color: '#4A7C59' }}>Flexible Options: </strong>We offer a range of repayment tenures, allowing you to choose a period that aligns with your financial capacity. Whether you prefer to clear your debt quickly or opt for smaller monthly installments, we have options to suit your needs.
                </p>
                <p style={{ color: '#6b7280', fontSize: '1.1rem', lineHeight: '1.7', margin: 0 }}>
                  <strong style={{ color: '#4A7C59' }}>EMI Calculation:</strong> Our Equated Monthly Installment (EMI) calculator helps you determine the exact amount you'll repay each month. This transparency enables you to plan your finances effectively.
                </p>
                <p style={{ color: '#6b7280', fontSize: '1.1rem', lineHeight: '1.7', margin: 0 }}>
                  <strong style={{ color: '#4A7C59' }}>Auto-Debit Facility:</strong> To ensure you never miss a payment, we offer an auto-debit facility. Your EMI amount is automatically deducted from your linked bank account, giving you peace of mind.
                </p>
                <p style={{ color: '#6b7280', fontSize: '1.1rem', lineHeight: '1.7', margin: 0 }}>
                  <strong style={{ color: '#4A7C59' }}>Online Payment:</strong> We provide a secure online platform for you to make your EMI payments conveniently. Say goodbye to long queues and enjoy the ease of digital transactions.
                </p>
                <p style={{ color: '#6b7280', fontSize: '1.1rem', lineHeight: '1.7', margin: 0 }}>
                  <strong style={{ color: '#4A7C59' }}>Timely Reminders:</strong> We send you timely reminders before your EMI due date, helping you stay on top of your repayment schedule.
                </p>
                <p style={{ color: '#6b7280', fontSize: '1.1rem', lineHeight: '1.7', margin: 0 }}>
                  <strong style={{ color: '#4A7C59' }}>No Hidden Charges:</strong> Our commitment to transparency means you won't encounter any hidden charges. The amount you agree upon during the loan approval process is what you'll repay – no surprises.
                </p>
              </div>
            </div>
          </div>

          {/* <div className="pan_number">
            <h2>What is the maximum and minimum repayment period at {APP_NAME}?</h2><br />
            <p>At {APP_NAME}, we allow you enough time and flexibility to repay your loan. This is done to ensure that repayments don’t feel like a burden. However, when it comes to the precise duration, the minimum repayment period is 60 days, and the maximum repayment period is 40 days.</p>
          </div> */}
        </div>

        <ChatButton />
      </div>
    </>
    );
  };

  export default RepayLoan;